import {
  LOAD_ALL_EQUIPMENTS,
  LOAD_ALL_EQUIPMENTS_SUCCESS,
  EQUIPMENTS_API_ERROR,
  INSERT_EQUIPMENTS,
  INSERT_EQUIPMENTS_SUCCESS,
} from "./actionTypes";


export const InsertEquipment = (user) => {
  return {
    type: INSERT_EQUIPMENTS,
    payload: { user },
  };
};
export const InsertEquipmentSuccess = () => {
  return {
    type: INSERT_EQUIPMENTS_SUCCESS,
    payload: {},
  };
};

export const loadAllEquipments = () => {
  return {
    type: LOAD_ALL_EQUIPMENTS,
    payload: {},
  };
};

export const loadAllEquipmentsSuccess = (equipments) => {
  return {
    type: LOAD_ALL_EQUIPMENTS_SUCCESS,
    payload: equipments,
  };
};

export const equipmentsApiError = (error) => {
  return {
    type: EQUIPMENTS_API_ERROR,
    payload: error,
  };
};
